import React from 'react'
import useIsUserAuthenticated from 'hooks/useIsUserAuthenticated'
import { Redirect } from 'react-router-dom'
import RouteWrapper from 'components/App/RouteWrapper'

const InauthenticatedOnlyRoute = (props) => {
  const userIsAlreadyLoggedIn = useIsUserAuthenticated()

  if(userIsAlreadyLoggedIn) {
    return <Redirect to='/' />
  }

  return <RouteWrapper { ...props } />
}

export default InauthenticatedOnlyRoute
